<template>
  <form v-if="!showRemoveUserPrompt" @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Sync User From FileMaker
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Identifier*">
          <d-input v-model="form.identifier " required />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Close
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Submit
        </d-btn>
      </footer>
    </div>
  </form>

  <form v-else @submit.prevent="removeUserAndSyncPost()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Sync User From FileMaker
        </p>
      </header>
      <section class="modal-card-body">
        <p class="mb-4">
          {{ removeUserMessage }}
        </p>
        <p>Would you like to remove the current active user with this email and sync the new user from Filemaker?</p>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Continue
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
  import axios from 'axios';

  export default {
    parent: true,

    data: () => ({
      saving: false,
      showRemoveUserPrompt: false,
      removeUserMessage: '',
      form: {
        identifier: '',
      },
    }),

    methods: {
      async saveForm() {
        this.showRemoveUserPrompt = false;
        this.removeUserMessage = '';
        this.saving = true;
        try {
          await axios.post(`/api/qcp-users/sync?identifier=${this.form.identifier}`);
          await this.$parent.events.getUsersPaged();
          this.$parent.close();
        } catch (error) {
          if (error.response.data[0].includes('currently in use by contact')) {
            this.showRemoveUserPrompt = true;
            this.removeUserMessage = error.response.data[0];
          } else {
            this.$toast.open({ message: error.response.data[0], color: 'error', duration: 4000 });
          }
        } finally {
          this.saving = false;
        }
      },

      async removeUserAndSyncPost() {
        this.saving = true;
        try {
          await axios.post(`/api/qcp-users/remove-user-and-sync?identifier=${this.form.identifier}`);
          await this.$parent.events.getUsersPaged();
          this.$parent.close();
        } catch (error) {
          this.$toast.open({ message: error.response.data[0], color: 'error', duration: 4000 });
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>